import React from 'react';
import { useHistory } from 'react-router';
import { useTracking } from 'react-tracking';
import { useAuth } from 'context/AuthContext/AuthContext';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import { signOut } from 'utils/apiUser';
import Icon from 'components/V1/Icon/Icon';
import {
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
  MenuPortal,
} from 'components/V1/Menu/Menu';
import { ReactComponent as LogOutIcon } from 'icons/log-out.svg';

interface UserMenuProps {
  /**
   * The element that opens the menu. Passed in rather than built here: the v1
   * and v2 shells style their avatars differently, and the sign-out behaviour
   * is the part worth sharing. Radix clones this via `asChild`, so it must be
   * a single element that forwards its ref and accepts DOM props.
   */
  readonly trigger: React.ReactElement;
}

function UserMenu({ trigger }: UserMenuProps) {
  const { environment } = useEnvironment();
  const { tokens, setTokens } = useAuth();
  const { trackEvent } = useTracking();
  const history = useHistory();

  function logOut() {
    signOut(tokens, environment);
    trackEvent({ name: 'log_out' });
    history.push('/');
    setTokens();
  }

  return (
    <Menu>
      <MenuButton asChild>{trigger}</MenuButton>
      <MenuPortal>
        <MenuList align="end" sideOffset={4}>
          <MenuItem onSelect={logOut}>
            <Icon as={LogOutIcon} />
            Log out
          </MenuItem>
        </MenuList>
      </MenuPortal>
    </Menu>
  );
}

export default UserMenu;
